import { defineStore } from 'pinia';
import _ from "lodash";
import {EventBus} from "@/event-bus";
import DataGatheringRepository from "@/Repositories/DataGathering/DataGatheringRepository";

export const DataGatheringsStore = defineStore('DataGatheringsStore', {
    state: () => ({
        academicPeriods: [],

        types: [],

        dataGatherings: [],

        commonRoutes: {
            explore_records: {
                name: null,
                parameters: null,
            },
        },
    }),

    getters: {

    },

    actions: {
        setAcademicPeriods(academicPeriods) {
            this.academicPeriods = academicPeriods;
        },

        setTypes(types) {
            this.types = types;
        },

        setDataGatherings(dataGatherings) {
            this.dataGatherings = dataGatherings;
        },

        setCommonRoute(key, name, parameters) {
            parameters = parameters || {};

            _.set(this.commonRoutes, key, {name, parameters});
        },

        getCommonRoute(key, parameters) {
            const commonRoute = _.get(this.commonRoutes, key);

            return route(commonRoute.name, Object.assign(commonRoute.parameters, parameters || {}));
        },

        async store(dataGathering) {
            const newDataGathering = await DataGatheringRepository.store(dataGathering);

            if(newDataGathering){
                this.dataGatherings = [newDataGathering, ...this.dataGatherings];

                EventBus.$emit('data-gatherings.data-gatherings.stored', _.cloneDeep(newDataGathering));
            }

            return newDataGathering;
        },

        async getRecuResume(dataGathering) {
            return await DataGatheringRepository.getRecuResume(dataGathering);
        },

        /**
         * @alias updateDataGathering
         * @param dataGathering
         * @returns {Promise<any>}
         */
        async update(dataGathering) {
            const updatedDataGathering = (await DataGatheringRepository.update(dataGathering)).data;

            if(await this.replaceInStore(updatedDataGathering)){
                EventBus.$emit('gicu-app.data-gatherings.update', _.cloneDeep(updatedDataGathering));
            }

            return updatedDataGathering;
        },

        /**
         *
         * @param dataGathering
         * @returns {Promise<any>}
         */
        async replace(dataGathering) {
            const replacedDataGathering = (await DataGatheringRepository.replace(dataGathering)).data;

            if(await this.replaceInStore(replacedDataGathering)){
                EventBus.$emit('gicu-app.data-gatherings.replace', _.cloneDeep(replacedDataGathering));
            }

            return replacedDataGathering;
        },

        /**
         *
         * @param dataGathering
         * @returns {Promise<*|null>}
         */
        async replaceInStore(dataGathering) {
            const dataGatherings = [...this.dataGatherings];
            const index = _.findIndex(dataGatherings, item => item.uuid === dataGathering.uuid);

            if(index !== -1){
                dataGatherings[index] = dataGathering;

                this.dataGatherings = dataGatherings;

                return dataGathering;
            }

            return null;
        },

        async delete(dataGathering) {
            const deletedDataGathering = (await DataGatheringRepository.delete(dataGathering)).data;

            const dataGatherings = [...this.dataGatherings];
            const index = _.findIndex(dataGatherings, dataGathering => dataGathering.uuid === deletedDataGathering.uuid);

            if(index !== -1){
                dataGatherings.splice(index, 1);

                this.dataGatherings = dataGatherings;

                EventBus.$emit('data-gatherings.data-gatherings.deleted', _.cloneDeep(deletedDataGathering));
            }

            return deletedDataGathering;
        },
    },
});
